module.exports = __webpack_public_path__ + "img/pet-friendly-img-2.13215333.jpg";